import { render, staticRenderFns } from "./question-Multiple.vue?vue&type=template&id=02a98492&scoped=true&"
import script from "./question-Multiple.vue?vue&type=script&lang=js&"
export * from "./question-Multiple.vue?vue&type=script&lang=js&"
import style0 from "./question-Multiple.vue?vue&type=style&index=0&id=02a98492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a98492",
  null
  
)

export default component.exports